var map = {
	"./76ers.png": 414,
	"./Blazers.png": 415,
	"./Bucks.png": 416,
	"./Bulls.png": 417,
	"./Cavaliers.png": 418,
	"./Celtics.png": 419,
	"./Clippers.png": 420,
	"./Grizzlies.png": 421,
	"./Hawks.png": 422,
	"./Heat.png": 423,
	"./Hornets.png": 424,
	"./Jazz.png": 425,
	"./Kings.png": 426,
	"./Knicks.png": 427,
	"./Lakers.png": 428,
	"./Magic.png": 429,
	"./Mavericks.png": 430,
	"./Nets.png": 431,
	"./Nuggets.png": 432,
	"./Pacers.png": 433,
	"./Pelicans.png": 434,
	"./Pistons.png": 435,
	"./Raptors.png": 436,
	"./Rockets.png": 437,
	"./Spurs.png": 438,
	"./Suns.png": 439,
	"./Thunder.png": 440,
	"./Timberwolves.png": 441,
	"./Warriors.png": 442,
	"./Wizards.png": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;